import React from 'react';
import './background.css';

/**
 * Purely decorative page backdrop: a faint drifting grid with soft accent
 * "aurora" blobs floating above it. CSS-only — no per-frame JavaScript — and
 * fully disabled under prefers-reduced-motion.
 */
function Background() {
  return (
    <div className="background" aria-hidden="true">
      <div className="background-grid" />
      <div className="background-aurora background-aurora--one" />
      <div className="background-aurora background-aurora--two" />
      <div className="background-aurora background-aurora--three" />
    </div>
  );
}

export default Background;
